import UserDialog from '@/components/UserDialog';
import { userAtom } from '@/global-store.jsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { IconEdit } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

// ==============================|| PROFILE INFOS ||============================== //
function ProfileInfos() {
    const [user] = useAtom(userAtom);
    const { t } = useTranslation();

    if (!user) {
        console.warn('User not found in ProfileInfos');
        return <></>;
    }

    const userInfo = {
        [t('name')]: user.surname + ' ' + user.name,
        [t('email')]: user.email,
        [t('phone')]: user.phone,
        [t('company')]: user.company,
        [t('key')]: user.apiKey
    };

    return (
        <Grid
            container
            direction='column'
            sx={{
                width: '100%',
                color: '#fff',
                overflowX: 'hidden',
                wordBreak: 'break-word'
            }}
        >
            <Grid mb={3} xs={12}>
                <Typography color='secondary' component='h3' variant='h4'>
                    {t('profileHeader')}
                </Typography>
            </Grid>

            {Object.entries(userInfo).map(([key, value], index) => (
                <Grid key={key} my={1} xs={12}>
                    <Grid
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                        container
                        direction={{
                            xs: 'column',
                            sm: 'row'
                        }}
                        flexWrap='nowrap'
                        gap={{
                            xs: 0,
                            sm: 6
                        }}
                        justifyContent='space-between'
                        key={index}
                    >
                        <Grid
                            sx={{
                                fontWeight: 300,
                                fontSize: '0.93rem',
                                flexShrink: 0,
                                whiteSpace: 'no-wrap'
                            }}
                        >
                            {key}
                        </Grid>

                        <Grid
                            sx={{
                                fontWeight: 500,
                                fontSize: '0.96rem',
                                textAlign: { xs: 'right', sm: 'left' },
                                maxWidth: '232px'
                            }}
                        >
                            {value || ' - '}
                        </Grid>
                    </Grid>
                </Grid>
            ))}

            <UserDialog
                hideOrgAdminToggle
                disableOrganisationSelect
                title={t('editProfile')}
                userData={user}
                activatorProps={{
                    startIcon: <IconEdit />,
                    sx: { mt: 3, outlineOffset: '-3px' },
                    variant: 'outlined',
                    color: 'secondary',
                    fullWidth: true
                }}
                activatorText={t('editProfile')}
                maxWidth='md'
            />
        </Grid>
    );
}

export default ProfileInfos;
